import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "BULLY_FIGHT",
  title: defineMessage({
    id: "fig.quality.BULLY_FIGHT.title",
    defaultMessage: `Percentage of students who experience bullying`,
  }),
  caption: defineMessage({
    id: "fig.quality.BULLY_FIGHT.caption",
    defaultMessage: `Being bullied at school is a common experience in all countries.`,
  }),
  source: defineMessage({
    id: "fig.quality.BULLY_FIGHT.source",
    defaultMessage: `UIS database`,
  }),
};
